var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.752,
    height: 52.3759,
    viewBox: "0 0 104.752 52.3759",
    fill: "none",
    id: "svg42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_2844)",
    id: "g16",
    style: {
      filter: "url(#filter0_d_416_2844)"
    },
    transform: "translate(-8,-6)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 104.752,
    height: 52.3759,
    rx: 3,
    fill: "#ffffff",
    id: "rect2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.841999,
    y: 10.3159,
    width: 5.3947401,
    height: 38.842098,
    transform: "rotate(90,46.842,10.3159)",
    fill: "#a2abcc",
    id: "rect4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.552498,
    y: 16.7896,
    width: 5.3947401,
    height: 89.552597,
    transform: "rotate(90,97.5525,16.7896)",
    fill: "#6371a8",
    id: "rect6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88.420898,
    y: 36.131302,
    width: 5,
    height: 81,
    transform: "rotate(90,88.4209,36.1313)",
    fill: "#a2abcc",
    id: "rect8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7104,
    y: 23.263201,
    width: 5.3947401,
    height: 50.710499,
    transform: "rotate(90,58.7104,23.2632)",
    fill: "#dadff2",
    id: "rect10"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 60,
    transform: "matrix(4.37114e-8,-1,-1,-4.37114e-8,67.4209,47.1313)",
    fill: "#6371a8",
    id: "rect12",
    x: 0,
    y: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5.3947301,
    height: 73.368401,
    transform: "matrix(4.37114e-8,-1,-1,-4.37114e-8,81.4209,53.5261)",
    fill: "#dadff2",
    id: "rect14",
    x: 0,
    y: 0
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs40"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_416_2844",
    x: 0,
    y: 0,
    width: 120.752,
    height: 68.3759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix",
    id: "feFlood20"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha",
    id: "feColorMatrix22"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    id: "feOffset24"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    id: "feGaussianBlur26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out",
    id: "feComposite28"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    id: "feColorMatrix30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_2844",
    id: "feBlend32"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_2844",
    result: "shape",
    id: "feBlend34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_2844"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 104.752,
    height: 52.3759,
    rx: 3,
    fill: "#ffffff",
    id: "rect37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.2dc27368229882f9ea4b5670d5aa6e7f.svg";
export { ForwardRef as ReactComponent };